export default class UserGeolocation {
  static async _isNavigatorUserGeolocationEnabled() {
    return navigator.permissions.query({ name: 'geolocation' });
  }

  static _navigatorUserGeolocation() {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  }

  static async isGeolocationEnabled() {
    const isGeolocationEnabled =
      await UserGeolocation._isNavigatorUserGeolocationEnabled();

    if (isGeolocationEnabled?.state === 'denied') {
      return {
        state: 'denied',
        userMessage: 'Acesso negado. A geolocalização está desabilitada.',
      };
    }

    return isGeolocationEnabled;
  }

  static async getUserGeolocation() {
    try {
      const position = await UserGeolocation._navigatorUserGeolocation();

      if (position?.coords) {
        const { latitude, longitude } = position.coords;

        return {
          position: {
            latitude,
            longitude,
          }
        };
      }
    } catch (err) {
      if (err.code === 1) {
        return {
          code: err.code,
          status: 'error',
          userMessage: 'Não foi possível acessar a localização!',
        };
      }

      return err;
    }
  }
}
